import request from "../web-sh/src/utils/request";
import global from "../config/global";

import resource from "../web-sh/src/services/resource";

async function get_countries() {
  return request({
    url: global.endpoint.RESOURCES_COUNTRIES,
    method: "get",
  });
}

async function get_plans() {
  return request({
    url: global.endpoint.RESOURCES_PLANS,
    method: "get",
  });
}

async function get_banner() {
  return request({
    url: global.endpoint.RESOURCES_BANNER,
    method: "get",
  });
}

async function get_lang() {
  return request({
    url: global.endpoint.RESOURCES_LANG,
    method: "get",
  });
}

export default {
  ...resource,
  get_countries,
  get_plans,
  get_banner,
  get_lang
}
